<template>
  <div>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
      <div slot="body">
        <div class="pay-mains">
          
          <div class="totals-box pl24 mt20">
            <div class="flex-row mb30">
              <div class="itemName">卡项名称</div>
              <div class="itemNum">{{ form.cardName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">卡项类型</div>
              <div class="itemNum moneys">{{ form.cardTypeCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">开卡门店</div>
              <div class="itemNum ">{{ form.shopName }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">开卡日期</div>
              <div class="">{{ formatDay(form.oxCtime) }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">失效日期</div>
              <div class="">{{ form.validDay == -1 ? '永久有效' : formatDay(form.validEndTime) }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">折扣卡状态</div>
              <div class="">{{ form.statusCn }}</div>
            </div>
            <div class="flex-row mb30">
              <div class="itemName">开卡操作人</div>
              <div class="">{{ form.oxLname }}</div>
            </div>
            <div v-if="form.status == 'disable'">
              <p class="order-title-boxs"><span class="blueBlock"></span><i>作废记录</i></p>
              <div class="flex-row mb30">
                <div class="itemName">作废门店</div>
                <div class="">{{ form.shopName }}</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">操作人</div>
                <div class="">{{ form.oxLname }}</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">作废日期</div>
                <div class="">{{ formatDay(form.oxLtime) }}</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName">备注</div>
                <div class="huanxin">{{ form.remark }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="drawer-footer pr24 pb10">
          <el-button type="primary" @click="back">返回</el-button>
          <el-button class="btn-dandu" v-perm="{key:'memberManager', value:'memberManager:invalid'}" v-if="form.invalidFlag" @click="invalid">作废此折扣卡</el-button>
        </div>
      </div>
    </drawer>
    <el-dialog title="作废备注" :visible.sync="centerDialogVisible" width="40%" center>
        <el-input type="textarea" placeholder="请输入内容" v-model="form.remark" maxlength="200" :rows="6" show-word-limit />
        <span slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import minxin from "../../assets/javascript/minxin.js";
import drawer from "../../components/common/drawer";
export default {
  mixins: [minxin],
  components: { drawer },
  data() {
    return {
      addEditTitle: "折扣卡详情",
      addEditShow: false,
      form: { },
      centerDialogVisible: false
    };
  },
  created() {
    this.editInit();
  },
  methods: {
    back () {
      this.addEditShow = false;
    },
    editInit() {
      this.$on("set", function(org) {
        Object.assign(this.$data, this.$options.data());
        this.addEditShow = true;
        this.$api.get(this.$url.card.get, {
            id: org.id
          }).then(res => {
            if (res) {
              console.log(res, 'sssssssssssssssssssss');
              this.form = res;
            }
          });
      });
    },
    invalid() {
        this.centerDialogVisible = true;
    },
    cancel() {
        this.form.remark = "";
        this.centerDialogVisible = false;
    },
    submit () {
        if (!this.form.remark) {
            return this.$message.error("请输入作废备注")
        }
        this.$api.get(this.$url.card.setInValid, this.form).then(res => {
            if (res) {
                this.$message.success("作废成功");
                this.centerDialogVisible = false;
                this.addEditShow = false;
                this.$emit("change", true);
            }
          });
    },
    handleChangeDrawer() {
      this.addEditShow = false;
      this.$emit("change", false);
    }
  }
};
</script>
<style scoped lang="less">
@import "../../assets/css/edit.less";
.pay-mains {
  padding: 0;
   .el-form {
    padding-bottom: 20px;
    /deep/ .el-form-item {
      border-bottom: 1px solid @borderColor;
      padding: 0 26px;
      margin-bottom: 0;
      // &:last-child {
      //   border-bottom: 0;
      // }
    }
    .el-form-item-update {
      height: 46px;
      align-items: center;
    //   display: flex;
      margin: 0;
      justify-content: space-between;
      border-bottom: 1px solid @borderColor;
      /deep/ .el-form-item__label {
        font-size: 16px;
        font-weight: 500;
        color: #333;
      }
      /deep/ .el-form-item__content {
        text-align: right;
        .el-form-item__error {
          right: 0;
        }
      }
      /deep/ .el-input__inner {
        height: 46px;
        padding: 0;
        text-align: right;
      }
      /deep/.el-select .el-input__inner {
        padding: 0 30px;
      }
      /deep/ .el-radio__inner {
        width: 22px;
        height: 22px;
      }
      /deep/ .el-radio__label {
        font-size: 16px;
      }

      /deep/ .el-input.is-disabled .el-input__inner {
        background: #fff;
      }
      /deep/ .el-link {
        width: 160px;
      }
      .money {
        color: @money;
      }
    }
    .el-form-item-remark {
      height: auto;
      min-height: 46px;
      /deep/ .el-form-item__content {
        margin-left: 0 !important;
        line-height: 1;
      }
    }
  }
}
.group-list {
  display: flex;
  // flex-direction: column;
  justify-content: space-between;
  padding: 10px 26px;
  color: #606266;
  border-bottom: 1px solid @borderColor;
  .list-left {
    .text {
      margin-right: 40px;
    }
    .time {
      margin-top: 10px;
    }
  }
  .list-right {
    .success {
      color: #57a900;
    }
    .wait {
      color: @blue;
    }
    .money {
      color: @money;
      margin-top: 10px;
    }
  }
}
.last-item {
    border-bottom: 0 !important;
}
.el-remark {
    padding: 20px !important;
    flex-direction: column;
    height: 100% !important;
    align-items: flex-start !important;
  }
</style>